/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppCloneEditVideoEditorEditsMutationRequest, WebAppCloneEditVideoEditorEditsMutationResponse, WebAppCloneEditVideoEditorEditsPathParams } from "../models/WebAppCloneEditVideoEditorEdits";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { webAppCloneEditVideoEditorEdits } from "../axios/webAppCloneEditVideoEditorEdits";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const webAppCloneEditVideoEditorEditsMutationKey = () => [{ url: '/web-app/v1/video-editor/edits/:id/clone' }] as const

export type WebAppCloneEditVideoEditorEditsMutationKey = ReturnType<typeof webAppCloneEditVideoEditorEditsMutationKey>

export function webAppCloneEditVideoEditorEditsMutationOptions<TContext = unknown>(config: Partial<RequestConfig<WebAppCloneEditVideoEditorEditsMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = webAppCloneEditVideoEditorEditsMutationKey()
        return mutationOptions<WebAppCloneEditVideoEditorEditsMutationResponse, ResponseErrorConfig<Error>, {id: WebAppCloneEditVideoEditorEditsPathParams["id"], data: WebAppCloneEditVideoEditorEditsMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ id, data }) => {
            return webAppCloneEditVideoEditorEdits(id, data, config)
          },
        })

}

/**
 * @summary Clone an edit (requires new name); response includes creator and published platforms
 * {@link /web-app/v1/video-editor/edits/:id/clone}
 */
export function useWebAppCloneEditVideoEditorEdits<TContext>(options: 
{
  mutation?: UseMutationOptions<WebAppCloneEditVideoEditorEditsMutationResponse, ResponseErrorConfig<Error>, {id: WebAppCloneEditVideoEditorEditsPathParams["id"], data: WebAppCloneEditVideoEditorEditsMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<WebAppCloneEditVideoEditorEditsMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? webAppCloneEditVideoEditorEditsMutationKey()

          const baseOptions = webAppCloneEditVideoEditorEditsMutationOptions(config) as UseMutationOptions<WebAppCloneEditVideoEditorEditsMutationResponse, ResponseErrorConfig<Error>, {id: WebAppCloneEditVideoEditorEditsPathParams["id"], data: WebAppCloneEditVideoEditorEditsMutationRequest}, TContext>
          

          return useMutation<WebAppCloneEditVideoEditorEditsMutationResponse, ResponseErrorConfig<Error>, {id: WebAppCloneEditVideoEditorEditsPathParams["id"], data: WebAppCloneEditVideoEditorEditsMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<WebAppCloneEditVideoEditorEditsMutationResponse, ResponseErrorConfig<Error>, {id: WebAppCloneEditVideoEditorEditsPathParams["id"], data: WebAppCloneEditVideoEditorEditsMutationRequest}, TContext>
      
}